import React from 'react';

import styled from 'styled-components';

import { useGroupsContext } from '../GroupsContext';

const Link = styled.span`
  color: var(--active-blue);
  font-size: 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  pointer-events: cursor;
`;

const GroupsFiltersReset = () => {
  const { filters, resetFilters } = useGroupsContext();

  const currentFilters = [filters.search, filters.status, filters.type, filters.has_users, filters.has_communities];
  const active = currentFilters.some((filter: any) => Boolean(filter?.length));

  if (!active) return null;

  return <Link onClick={resetFilters}>Reset</Link>;
};

export default GroupsFiltersReset;
